import axios from "axios";
import { baseUrl } from "../../config/clientsConfig";

const employeeAnalyticsService = {
  getEmployeeAnalyticsList: async (body) => {
    const response = await axios.post(
      `${baseUrl}/employee-analytics/all`,
      body
    );

    return response;
  },
  createEmployeeNotes : async (body) => {
    return await axios.post(`${baseUrl}/employee-analytics/create-note`, body);
  },
  createEmployeeFine : async (body) => {
    return await axios.post(`${baseUrl}/employee-analytics/create-fine`, body);
  },
  createEmployeeAbsence : async (body) => {
    return await axios.post(`${baseUrl}/employee-analytics/mark-absent`, body);
  },
  createEmployeeLeave : async (body) => {
    return await axios.post(`${baseUrl}/employee-analytics/mark-leave`, body);
  },
  createEmployeeHalfDay : async (body) => {
    return await axios.post(`${baseUrl}/employee-analytics/mark-halfday`, body);
  },
  createEmployeeOvertime : async (body) => {
    return await axios.post(`${baseUrl}/employee-analytics/mark-overtime`, body);
  },
  updateEmployeePresent : async (body) => {
    return await axios.post(`${baseUrl}/employee-analytics/mark-present`, body);
  },


  employeeCardCount: async (body) => {
    return await axios.post(`${baseUrl}/employee-analytics/card`, body);
  },
  employeeInfo: async (body) => {
    return await axios.post(`${baseUrl}/employee-analytics/details`, body);
  },

  getEmployeeMonthlySummary: async (body) => {
    return await axios.post(`${baseUrl}/employee-analytics/monthly-analytics`, body);
  }

};

export default employeeAnalyticsService;
